class SsrPromiseHelper {
  bucket = {};
}

const ssrPromiseHelper = new SsrPromiseHelper();

export default ssrPromiseHelper;
